import { FetchRecommendedHubRequestTypes } from '../actions/RecommendedHubActions';
const initialState = {};

const RecommendedHub = (state = initialState, {
  type,
  payload
}) => {
  switch (type) {
    case FetchRecommendedHubRequestTypes.RECEIVE:
      {
        const {
          data
        } = payload;
        return data;
      }

    default:
      return state;
  }
};

export default RecommendedHub;